import template from './picker.component.html';

/* @ngInject */
function pickerController(
  DateTimeRangePickerService
) {
  const vm = this;
  vm.selectDate = selectDate;
  vm.$onInit = $onInit;
  vm.hasChanged = hasChanged;
  vm.selectTimeRange = selectTimeRange;
  vm.dateSetManually = dateSetManually;
  vm.isValidDateRange = isValidDateRange;
  vm.activeSelection = '';
  vm.showDateRangeSelector = false; // TODO: remove?
  vm.dpOptions = {
    showWeeks: false,
    formatMonth: 'MMM',
    yearColumns: 3
  };
  const setVmProps = opts => _.merge(vm, _.pick(opts, ['start', 'end', 'activeSelection']));

  function $onInit() {
    !(vm.start && vm.end) && setVmProps(DateTimeRangePickerService.setToday());
  }

  function hasChanged() {
    vm.changed = true;
  }

  function selectTimeRange(opts) {
    setVmProps(opts);
    vm.hasChanged();
  }

  function selectDate(date) {
    dateSetManually(date);
    vm.rangeMode = true;
  }

  function dateSetManually() {
    vm.activeSelection = '';
    vm.hasChanged();
  }

  function isValidDateRange() {
    return DateTimeRangePickerService.isValidDateRange({ start: vm.start, end: vm.end });
  }

}

export default {
  name: 'picker',
  controller: pickerController,
  template,
  bindings: {
    start: '=?',
    end: '=?',
    changed: '=?',
    modalMode: '<?',
    done: '=',
    cancel: '='
  }
};
